export default "__VITE_ASSET__Dx7h$2tK__"